import { supabase } from './supabase';
import type { Quote } from './api';

export type NewQuote = Omit<Quote, 'id' | 'created_at' | 'updated_at'>;

const TABLE = 'quotes';

export async function listQuotes(includeInactive = false): Promise<Quote[]> {
  let query = supabase
    .from(TABLE)
    .select('*')
    .order('created_at', { ascending: false });

  if (!includeInactive) {
    query = query.eq('is_active', true);
  }

  const { data, error } = await query;

  if (error) throw error;
  return (data as Quote[]) || [];
}

export async function createQuote(input: NewQuote): Promise<Quote> {
  const payload = {
    text: input.text,
    author: input.author,
    category: input.category,
    is_active: input.is_active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();

  if (error) throw error;
  return data as Quote;
}

export async function updateQuote(id: string, input: NewQuote): Promise<Quote> {
  const payload = {
    text: input.text,
    author: input.author,
    category: input.category,
    is_active: input.is_active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .update(payload)
    .eq('id', id)
    .select('*')
    .single();

  if (error) throw error;
  return data as Quote;
}

export async function deleteQuote(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);

  if (error) throw error;
}

export default {} as unknown;
